import { render } from "./DiagnosisRepair.vue?vue&type=template&id=41931d23&scoped=true&ts=true&lang=pug"
import script from "./DiagnosisRepair.vue?vue&type=script&lang=ts"
export * from "./DiagnosisRepair.vue?vue&type=script&lang=ts"

import "./DiagnosisRepair.vue?vue&type=style&index=0&id=41931d23&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41931d23"]])

export default __exports__